<template>
  <div class="modules-settings-tenancy-users">
    <div class="title-container">
      <div class="title-container-left">
        <a
          class="all-tenants"
          @click="navToPage('all-tenants')"
        >{{ $t('view') }} {{ $t('settings.user.tenant.all') }}</a>
        <div calss="total-wth-refresh">
          <span>{{ $t('total') }}: {{ orderedUsers.length }} / {{ recordCounts }}</span>
          <i
            id="tenancy_user_refresh"
            class="fa fa-refresh dark flat icon_refresh"
            @click="init()"
          />
        </div>
      </div>
      <HKLButton
        color="darkblue"
        action="resetFilter"
        @click="resetFilter"
        class="reset-btn"
      />
    </div>

    <div class="tender-table">
      <table>
        <thead>
          <th
            v-for="(header, index) in itemHeaders"
            :class="header.class"
            @click="sortBy(header.code)"
            :key="index"
          >
            {{ $t(header.name) }} {{ tenancySorting.orderbyAttr === header.code ? tenancySorting.reverse ? '&#9660;' : '&#9650;' : null }}
          </th>
        </thead>
        <tbody>
          <tr>
            <td>
              <input
                type="text"
                class="setting-users-filter-search"
                id="settings-users-tenancy-user-search"
                v-model="tenancyFilter.userAccount"
              >
            </td>

            <td class="settings-filter align-center">
              <HKLSelect
                :value="tenancyFilter.isMasterAccount"
                class="align-center"
                settings-filter-row
                :options="ynHklOptions"
                :showSearch="false"
                placeholder=""
                @change="val => { tenancyFilter.isMasterAccount = val }"
              />
            </td>
            <td colspan="2">
              <!-- placeholder -->
            </td>
          </tr>
          <tr
            v-for="(item, index) in orderedUsers"
            :key="index"
          >
            <td>
              <div class="align-left">
                <a @click="navToDetail(item.id)">{{ item.userAccount }}</a>
              </div>
            </td>
            <td>
              <div>{{ item.isMasterAccount ? ynOptions.YES : ynOptions.NO | customYNLabel }}</div>
            </td>
            <td>
              <div>{{ item.lastLoginOn }}</div>
            </td>
            <td>
              <div>{{ item.lastInvitedAt }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

import HKLSelect from '@/controls/Select/HKLSelect.vue'
import HKLButton from '@/controls/Button/HKLButton'

import dateUtil from '@/utils/dateUtil'
import { getUserByUserRole } from '@/api/users/request'
import useRegionRef from '@/utils/useRegionRef'
import { computed, getCurrentInstance, unref } from 'vue-demi'

const ynOptions = {
  ALL: 'All',
  YES: 'YES',
  NO: 'No',
}

const initFilter = {
  isMasterAccount: ynOptions.ALL,
  orderbyAttr: 'lastLoginOn',
  userAccount: '',
}

const initSort = {
  orderbyAttr: 'lastLoginOn',
  reverse: 0,
}

function getDefaultData () {
  return {
    ynOptions,
    itemHeaders: [{
      code: 'userAccount',
      name: 'settings.user.userAccount',
      class: 'email-align',
      filter: '',
    }, {
      code: 'isMasterAccount',
      name: 'settings.user.isMasterAccount',
      filter: ynOptions.ALL,
    }, {
      code: 'lastLoginOn',
      name: 'lastLogin',
    }, {
      code: 'lastInvitedAt',
      name: 'invitedAt',
    }],
  }
}

const tenancyFilter = useRegionRef(initFilter, { logoutReset: true })
const tenancySorting = useRegionRef(initSort, { logoutReset: true })
const tenancyResult = useRegionRef([], { logoutReset: true })
export default {
  name: 'TenancyUsers',
  components: {
    HKLSelect,
    HKLButton,

  },
  setup () {
    const { proxy } = getCurrentInstance()
    const ynHklOptions = computed(() =>
      Object.values(ynOptions).map((value) => ({
        name: proxy.$options.filters.customYNLabel(value),
        value,
      })),
    )
    const filteredResult = computed(() => {
      return unref(tenancyResult).filter((item) => {
        const isMasterFilter = unref(tenancyFilter).isMasterAccount
        const isMasterAccount = item.isMasterAccount ? proxy.ynOptions.YES : proxy.ynOptions.NO
        const matched = proxy.matchFilter(item.userAccount, unref(tenancyFilter).userAccount) &&
            (isMasterFilter === proxy.ynOptions.ALL || isMasterFilter === isMasterAccount)
        return matched
      })
    })
    const orderedUsers = computed(() => {
      const result = _.orderBy(unref(filteredResult), ['lastLoginOn', 'lastInvitedAt'].includes(unref(tenancySorting).orderbyAttr) ? (o) => {
        return dateUtil.parse(o[unref(tenancySorting).orderbyAttr]).valueOf() || 0
      } : unref(tenancySorting).orderbyAttr)
      return unref(tenancySorting).reverse ? result.reverse() : result
    })
    const recordCounts = computed(() => {
      return (unref(tenancyResult) || []).length
    })
    const resetFilter = () => {
      tenancyFilter.value = { ...initFilter }
      tenancySorting.value = { ...initSort }
    }
    return {
      orderedUsers,
      ynHklOptions,
      tenancyFilter,
      tenancySorting,
      tenancyResult,
      resetFilter,
      recordCounts,
    }
  },
  data: getDefaultData,
  async mounted () {
    if (!this.tenancyResult.length) {
      await this.init()
    }
  },
  methods: {
    sortBy (attr) {
      if (this.tenancySorting.orderbyAttr === attr) {
        this.tenancySorting.reverse = !this.tenancySorting.reverse
      }
      this.tenancySorting.orderbyAttr = attr
    },
    getInfoFromTenancies (tenancies = []) {
      let isMasterAccount = false
      let isSubAccount = false
      let lastInvitedAt
      if (tenancies.length) {
        tenancies.forEach(item => {
          if (deep(item, 'TenancyAccount.isAdmin')) {
            isMasterAccount = true
          } else {
            isSubAccount = true
          }
          const invitedAt = deep(item, 'TenancyAccount.invitedAt')
          if (invitedAt && (!lastInvitedAt || (+new Date(invitedAt) > +new Date(lastInvitedAt)))) {
            lastInvitedAt = invitedAt
          }
        })
      }

      return { isMasterAccount, isSubAccount, lastInvitedAt }
    },

    buildTenancyUserMetaData (originUsers) {
      const users = originUsers.map(user => {
        const result = this.getInfoFromTenancies(user.tenancies)
        return {
          id: user.id,
          userAccount: user.username,
          isMasterAccount: result.isMasterAccount,
          isSubAccount: result.isSubAccount,
          lastLoginOn: this.formatDate(user.lastLoginAt),
          lastInvitedAt: this.formatDate(result.lastInvitedAt),
        }
      })
      return users
    },

    async init () {
      const userRole = 'tenant'
      const originUsers = await getUserByUserRole(userRole)
      this.tenancyResult = this.buildTenancyUserMetaData(originUsers)
    },
    formatDate (dateString) {
      return dateUtil.formatDate(dateString, true)
    },
    navToPage (name, id) {
      this.$router.push({
        name,
        params: {
          id,
        },
      })
    },
    navToDetail (id) {
      if (id) {
        this.navToPage('tenancy-user-detail', id)
      }
    },
    formatForMatch (value) {
      return value ? value.toString().toLowerCase().replace(/ /g, '') : value
    },
    matchFilter (target, filter) {
      return filter ? target && (this.formatForMatch(target).indexOf(this.formatForMatch(filter)) !== -1) : true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/settings/style';

.modules-settings-tenancy-users {
  .title-container {
    display: flex;
    justify-content: space-between;
    .reset-btn {
      height: 40px;
    }
  }
  .total-users__number {
    display: inline-block;
    height: 20px;
    border-radius: 10px;
    background-color: #0C3A58;
    color: white;
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    line-height: 20px;
    padding: 0 6px;
    margin-right: 10px;
  }
  .total-users__label {
    font-weight: bold;
    font-size: 12px;
  }
  thead>th {
    cursor: pointer;
  }
  tbody tr td {
    padding-left: 2px;
    a {
      padding-left: 0;
    }
  }

  .email-align {
    text-align: left!important;
  }
  .align-center {
    margin: auto
  }
  .title-container-left{
    display: flex;
    flex-direction: column;
    .all-tenants {
      display: inline;
      text-decoration: underline;
      padding: 0 0 20px 0;
      font-style: Italic;
    }
  }
}
</style>
